module.exports = __webpack_public_path__ + "img/bj35.4590b186.png";